import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import useDorisMarketShareHooks from 'src/serverProxy/useDorisMarketShareHooks';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import {
  useBusinessUnitEntity,
  useCategoryEntity,
  useSegmentEntity,
  useSubcategoryEntity
} from 'src/utils/Hooks/reduxSelectors';

const AtlasUnitsSold1PTotalUnitsSoldSplineChart = () => {
  const { requestBuilder: defaultMarketShareNumeratorRequestBuilder } = useDorisMarketShareHooks();
  const { isSegmentEntity } = useSegmentEntity();
  const { isBusinessUnitEntity } = useBusinessUnitEntity();
  const { isCategoryEntity } = useCategoryEntity();
  const { isSubcategoryEntity } = useSubcategoryEntity();
  return (
    <AtlasV2DorisSplineChart
      queryKey="UnitsSold1PTotalUnitsSoldSplineChart"
      title="1P Units Sold as % of Total"
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType="firstPartyUnitsSold"
      showMarketShare={true}
      marketShareNumeratorRequestBuilder={(params) => {
        const returnParams = { ...defaultMarketShareNumeratorRequestBuilder(params) };
        if (isSegmentEntity || isBusinessUnitEntity || isCategoryEntity || isSubcategoryEntity) {
          returnParams.brandIds = [];
        }
        return returnParams;
      }}
      marketShareRequestBuilder={(params) => {
        return {
          ...params,
          metricType: 'unitsSold'
        };
      }}
    />
  );
};

export default AtlasUnitsSold1PTotalUnitsSoldSplineChart;
